import { useAuth } from "@/contexts/auth-context";
import type { UserRole } from "@/types/auth";
import { getUserRole } from "@/types/auth";
import { DistrictManagerCards } from "./district-manager-cards";
import { ResellerCards } from "./reseller-cards";
import { ResellerManagerCards } from "./reseller-manager-cards";

export { formatConsumption } from "./dashboard-utils";
export { StatCard } from "./stat-card";

interface DashboardCardsProps {
	districtId?: number | null;
	startDate?: string;
	endDate?: string;
	viewRole?: UserRole;
	resellerId?: number | null;
}

export function DashboardCards({
	districtId,
	startDate,
	endDate,
	viewRole,
	resellerId,
}: DashboardCardsProps) {
	const { user } = useAuth();
	if (!user) return null;

	const role = viewRole ?? getUserRole(user);

	if (role === "district_manager")
		return (
			<DistrictManagerCards
				districtId={districtId}
				startDate={startDate}
				endDate={endDate}
			/>
		);
	if (role === "reseller")
		return (
			<ResellerCards
				districtId={districtId}
				startDate={startDate}
				endDate={endDate}
			/>
		);
	if (role === "reseller_manager")
		return (
			<ResellerManagerCards
				districtId={districtId}
				startDate={startDate}
				endDate={endDate}
				resellerId={resellerId}
			/>
		);
	return null;
}
